import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@atlaskit/tooltip';
import { routePaths, STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { useFeatureToggle } from '@css-xp/base';
import { NoData } from './no-data';

export interface CloudSiteLinkProps {
  siteName?: string | null;
  txaId?: string | null;
  cloudSiteId?: string | null;
  shouldRemoveLineClamp?: boolean;
  isOrgProductEntitlement?: boolean;
}

export const CloudSiteLink = ({
  siteName,
  txaId,
  cloudSiteId,
  shouldRemoveLineClamp,
  isOrgProductEntitlement,
}: CloudSiteLinkProps) => {
  const [isEnabled] = useFeatureToggle();
  const isDesignIteration1Enabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_DESIGN_ITERATION_1);

  // Classes for truncating after multiple lines with ellipsis
  const defaultStyleClasses = shouldRemoveLineClamp ? 'site-name-link' : 'line-clamp site-name-link';

  if (!siteName || siteName === '') {
    if (isDesignIteration1Enabled && !isOrgProductEntitlement) {
      return <>Setup required</>;
    }

    return <NoData />;
  }

  if (!txaId) {
    return (
      <Tooltip content={siteName} tag="span" position="bottom-start">
        <span className={defaultStyleClasses} data-testid={`cloud-site-name-${cloudSiteId ?? siteName}`}>
          {siteName}
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip content={siteName} tag="span" position="bottom-start">
      <Link
        className={defaultStyleClasses}
        data-testid={`cloud-site-url-${cloudSiteId ?? siteName}`}
        to={getRouteUrl(routePaths.cloudSite, {
          txaId: txaId,
          cloudSiteId: cloudSiteId ?? '',
        })}
        onClick={(e) => e.stopPropagation()}
      >
        {siteName}
      </Link>
    </Tooltip>
  );
};
